import Vue from 'vue'
import VueRouter from 'vue-router'

import Audio from '../components/audio-list'
// import Detail from '../components/detail'
// import Order from '../components/order'
// import Referent from '../components/referent'
// import Login from '../components/login'
// import Register from '../components/register'
// import Newsletter from '../components/newsletter'

Vue.use( VueRouter )

export default new VueRouter({
  // mode: 'history',
  routes: [
    { path: '/', name: 'programm', component: Audio },
    { path: '/cat/:cat', name: 'programm-cat', component: Audio },
    // { path: '/referents/:id', name: 'referent', props: true, component: Referent },
    // { path: '/agendas/:id', name: 'detail', props: true, component: Detail },
    // { path: '/order', name: 'order', component: Order },
    // { path: '/login', name: 'login', component: Login },
    // { path: '/register', name: 'register', component: Register },
    // { path: '/newsletter', name: 'newsletter', component: Newsletter },
  ]
})
